import { render, staticRenderFns } from "./NvBookCover.vue?vue&type=template&id=a1cf4c7c&scoped=true&"
import script from "./NvBookCover.vue?vue&type=script&lang=js&"
export * from "./NvBookCover.vue?vue&type=script&lang=js&"
import style0 from "./NvBookCover.vue?vue&type=style&index=0&id=a1cf4c7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1cf4c7c",
  null
  
)

export default component.exports